module.exports = __webpack_public_path__ + "media/images/hitfun3/icon.prize.money-f7eb6a7c51ba21ccd87b1cd1da7852e8.svg";